import _regeneratorRuntime from "@babel/runtime/regenerator";
import { takeEvery } from 'redux-saga/effects';
import { SEND_COMMAND_REQUEST } from '../internal/action-types';
import sendCommandSaga from './send-command-saga';

var isSendCommandAction = function isSendCommandAction(action) {
  return action.type === SEND_COMMAND_REQUEST;
};

var commandSaga = /*#__PURE__*/_regeneratorRuntime.mark(function commandSaga(sagaArgs) {
  return _regeneratorRuntime.wrap(function commandSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return takeEvery(function (action) {
            if (isSendCommandAction(action)) {
              return !action.usedByHook;
            }

            return false;
          }, sendCommandSaga, sagaArgs);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, commandSaga);
});

export default commandSaga;
//# sourceMappingURL=command-saga.js.map